module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/6bacea0285bb005dd1143fd40478d644.svg";